(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-ctm"] && !Shopify.designMode) return;
  try {
    class ProductGallerySlider extends HTMLElement {
  connectedCallback() {
    if (typeof Swiper === 'undefined') return;

    const gallery = this.closest('.pgs-gallery');
    const thumbsEl = gallery.querySelector('.pgs-thumbs');
    
    const thumbsSwiper = new Swiper(thumbsEl, {
      slidesPerView: 3,
      spaceBetween: 8,
      scrollbar: {
        el: gallery.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      navigation: {
        nextEl: gallery.querySelector('.thumb-next'),
        prevEl: gallery.querySelector('.thumb-prev'),
      },
    });

    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      grabCursor: true,
      loop: false,
      thumbs: { swiper: thumbsSwiper },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    // When a variant is selected, jump the gallery to that variant's featured media slide
    const section = this.closest('.shopify-section');
    if (section) {
      section.addEventListener('variant:update', (event) => {
        const featuredMedia = event.detail && event.detail.resource && event.detail.resource.featured_media;
        if (!featuredMedia || !this.swiper) return;

        const mediaId = featuredMedia.id;
        const slides = Array.from(this.querySelectorAll('.pgs-main__slide[data-media-id]'));
        const targetIndex = slides.findIndex((slide) => parseInt(slide.dataset.mediaId, 10) === mediaId);

        if (targetIndex !== -1) {
          this.swiper.slideTo(targetIndex, 300);
        }
      });
    }
  }
}

if (!customElements.get('product-gallery-slider')) {
  customElements.define('product-gallery-slider', ProductGallerySlider);
}
  } catch(e) { console.error(e); }
})();

})();
